// src/pages/admin/Dissolution.js
import React from "react";
import FormWrapper from "../../forms/shared/FormWrapper";

// ฟอร์ม “เชิญประชุมอนุมัติจ่ายเงินปันผล”
import DissolutionForm from "../../forms/move/Dissolution/Dissolution";

function DissolutionPage() {
  return (
    <FormWrapper
      title="เลิกห้างหุ้นส่วนจำกัด"
      FormComponent={DissolutionForm}
      formKey="Dissolution"
    />
  );
}

export default DissolutionPage;
